/**
 * notify.js
 * ─────────
 * Fire-and-forget POST to /api/notify so Saleem gets a WhatsApp on every
 * new lead / message / booking / partnership. Called immediately after a
 * successful Supabase insert.
 *
 * Guarantees:
 *   - NEVER throws (silently logs on failure). A notification failure must
 *     not block the user's form-success screen.
 *   - Fire-and-forget: doesn't await the backend response. The backend also
 *     ACKs 202 Accepted immediately and dispatches Twilio in a bg thread.
 *   - Idempotency: we don't retry client-side. If the network is flaky, the
 *     row is still in Supabase and shows up on the admin bell within 20s.
 */

const BACKEND = process.env.REACT_APP_BACKEND_URL || '';

/**
 * @param {string} eventType — one of:
 *   partnership_request | counseling_booking | lead | contact_message
 *   | notify_signup | eager_minds | grant_claim | signup
 * @param {object} payload — bag of the row's key display fields. See
 *   /app/backend/notify_service.py `_FORMATTERS` for what each event type
 *   consumes.
 */
export function notifyAdmin(eventType, payload = {}) {
    if (!BACKEND) return; // e.g. Storybook / test envs
    try {
        // NOTE: intentionally not `await`ed. We want zero perceived latency
        // for the user's form-submit. Even a 30ms POST would slow the UX.
        fetch(`${BACKEND}/api/notify`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ event_type: eventType, payload }),
            // keepalive so the browser doesn't cancel the POST if the user
            // navigates away right after clicking Submit (common on mobile).
            keepalive: true,
        }).catch(() => { /* swallow — safety net only */ });
    } catch { /* swallow */ }
}
